import { createServerFn } from '@tanstack/react-start';
import {
  claimDailyCheckIn,
  getDailyCheckInStatus,
} from '@/credits/daily-check-in';
import { authApiMiddleware } from '@/middlewares/auth-middleware';

export const getDailyCheckIn = createServerFn({ method: 'GET' })
  .middleware([authApiMiddleware])
  .handler(async ({ context }) => getDailyCheckInStatus(context.userId));

export const claimDailyCheckInReward = createServerFn({ method: 'POST' })
  .middleware([authApiMiddleware])
  .handler(async ({ context }) => claimDailyCheckIn(context.userId));
